export default __webpack_public_path__ + "static/media/What we do-eachpage-Website_Development.daf67396.png";